import React from 'react';
import CurrencySymbol from '../../CurrencySymbol';
import math, { formatNumber } from '../../../utils/math';
import intl from 'react-intl-universal';

// 价格详情组件
const PriceDetails = ({ priceItem, priceObj, storeInfo, pdCurrency, discountAmount, productPriceIncludeFee, hideFeeRate, previewFees }) => {
    const serviceAmount = previewFees ? previewFees.serviceFee : priceItem.pd_service
    const taxAmount = previewFees ? previewFees.taxFee : priceItem.pd_tax
    const totalAmount = previewFees
        ? previewFees.totalPrice
        : math.add(priceItem.totalPrice, productPriceIncludeFee)
    const showService = previewFees ? true : priceItem.pd_service_cls !== 'hide'
    const showTax = previewFees ? true : priceItem.pd_tax_cls !== 'hide'
    const showServiceRate = !hideFeeRate && storeInfo.serviceFeeRate > 0 && storeInfo.serviceFeeType !== 4
    const showTaxRate = !hideFeeRate && storeInfo.taxRate > 0 && storeInfo.taxType !== 4

    return (
    <article className='bk-price-list'>
        {
            priceItem.pd_service_cls !== 'hide' && priceItem.pd_tax_cls !== 'hide' && (
                <section className='jm-flex hide'>
                    <div className='jm-flex-item'>{intl.get('price').d('Price')}</div>
                    <div className='text-gray'>
                        <CurrencySymbol currency={pdCurrency} />
                        {formatNumber(priceItem.pd_actual_price)}
                        {discountAmount > 0 && (
                            <small style={{ color: '#666', textDecoration: 'line-through' }}>
                                <CurrencySymbol currency={pdCurrency} />
                                {formatNumber(math.add(priceItem.pd_actual_price, discountAmount))}
                            </small>
                        )}
                    </div>
                </section>

            )
        }

        {showService && (
            <section className='jm-flex'>
                <div className='jm-flex-item'>
                    {intl.get('fees').d('服务费')}
                    {
                        showServiceRate ?
                            <>
                                ({math.mul(storeInfo.serviceFeeRate, 100)}%)
                            </> : null
                    }
                </div>
                <div className='text-gray'>
                    <CurrencySymbol currency={pdCurrency} />
                    {formatNumber(serviceAmount)}
                </div>
            </section>
        )}
        {showTax && (
            <section className='jm-flex'>
                <div className='jm-flex-item'>
                    {intl.get('taxes').d('税费')}
                    {
                        showTaxRate ?
                            <>
                                ({math.mul(storeInfo.taxRate, 100)}%)
                            </> : null
                    }
                </div>
                <div className='text-gray'>
                    <CurrencySymbol currency={pdCurrency} />
                    {formatNumber(taxAmount)}
                </div>
            </section>
        )}
        <section className='jm-flex clear-bg'>
            <div className='jm-flex-item'>{intl.get('total').d('Total')}</div>
            <div style={{ color: 'var(--adm-color-primary)', fontWeight: 'bold' }}>
                <CurrencySymbol currency={pdCurrency} />
                {formatNumber(totalAmount)}
            </div>
        </section>
    </article>
    )
}

export default PriceDetails; 